import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

import { getIssueConfirmationById } from '../../../../../packages/common/api';
import { useTranslation } from '../../../../../packages/common/utils/getLocalString';
import { generateRedirectUrl } from '../../../../../packages/common/utils/getRedirectUrl';

// Original class: rowLink
const StyledRowLink = styled(Link)(theme => ({
  transition: '.4s ease',

  '&:hover': {
    textDecoration: 'underline',
  },
}));

const IssueConfirmations = ({ projectId }) => {
  const getLocalString = useTranslation();
  const params = useParams();
  const [confirmations, setConfirmations] = useState(null);

  useEffect(() => {
    let ignore = false;
    async function getConfirmations() {
      const { data: children } = await getIssueConfirmationById(params.id);
      if (!ignore) {
        return children;
      }
    }
    getConfirmations()
      .then(res => {
        setConfirmations(res);
      })
      .catch(error => console.error(error, 'ERROR IN GET ISSUE'));
    return () => {
      ignore = true;
    };
  }, [params.id]);
  const handleUrl = useCallback((columnType, value) => {
    switch (columnType) {
      case 'confirmation.confirmation':
        return `${window.location.origin}/confirmations/${value.valueId}`;
      default:
        return '';
    }
  }, []);
  const RowCellComponent = useCallback(
    ({ type, value }) => {
      if (!value.valueName) {
        return '';
      }
      if (type === 'confirmation.confirmation') {
        return (
          <StyledRowLink to={handleUrl(type, value)} target={'_blank'}>
            {value.valueName}
          </StyledRowLink>
        );
      }
      return (
        <Typography
          component='span'
          sx={{
            color: '#212346',
            fontSize: '14px',
            lineHeight: '20px',
          }}
        >
          {type === 'issue.start' || type === 'issue.end'
            ? dayjs(value.valueName).format('DD.MM.YYYY')
            : value.valueName}
        </Typography>
      );
    },
    [handleUrl],
  );

  return (
    <>
      <Grid
        container
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid>
          <Typography
            variant='h3'
            sx={{
              color: '#082253',
              fontWeight: 600,
            }}
          >
            {getLocalString('Confirmations', 'title')}
          </Typography>
        </Grid>
      </Grid>
      {confirmations && confirmations.rows.length > 0 && (
        <TableContainer sx={{ marginTop: '10px' }}>
          <Table>
            <TableHead>
              <TableRow>
                {confirmations.fields.map((item, index) => (
                  <TableCell
                    key={index}
                    sx={{ border: 'none', padding: '0 4px 4px 0!important' }}
                  >
                    <Typography
                      variant='h4'
                      sx={{
                        color: '#212346',
                        fontWeight: 600,
                      }}
                    >
                      {item.fieldName}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {confirmations.rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row.columns.map((column, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        border: 'none',
                        padding: '4px 4px 4px 0!important',
                      }}
                    >
                      <RowCellComponent
                        type={column.fieldId}
                        value={{
                          valueName: column.value,
                          valueId: column.valueId,
                        }}
                      ></RowCellComponent>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default IssueConfirmations;
